import React from 'react';
import PropTypes from 'prop-types';

export default class Carousel extends React.Component {
  constructor() {
    super();
    this.state = { currentIndex: 0 };
    this.autoScrollTimer = undefined;

    this.getDisplayItemIndicies = this.getDisplayItemIndices.bind(this);
    this.changeCurrentIndex = this.changeCurrentIndex.bind(this);
  }

  componentDidMount() {
    const { autoScroll, autoScrollTime } = this.props;
    
    if (autoScroll) {
      this.autoScrollTimer = setInterval(() => this.incrementCurrentIndex(), autoScrollTime);
    }
  }

  componentWillUnmount() {
    if (this.autoScrollTimer) {
      clearInterval(this.autoScrollTimer);
    }
  }

  setCurrentIndex(index) {
    const { totalNumberOfItems } = this.props;

    this.setState({ currentIndex: index % totalNumberOfItems });
  }

  getDisplayItemIndices() {
    const { numberOfDisplayItems, totalNumberOfItems } = this.props;
    const { currentIndex } = this.state;

    const displayIndices = new Array(numberOfDisplayItems)
      .fill(currentIndex)
      .map((i, index) => (i + index) % totalNumberOfItems);

    return displayIndices;
  }

  changeCurrentIndex(index) {
    const { totalNumberOfItems } = this.props;
    if (index < 0) {
      this.setCurrentIndex(totalNumberOfItems - 1);
    } else if (index === totalNumberOfItems) {
      this.setCurrentIndex(0);
    } else {
      this.setCurrentIndex(index);
    }
  }

  incrementCurrentIndex() {
    const { currentIndex } = this.state;

    this.setCurrentIndex(currentIndex + 1);
  }

  render() {
    const { currentIndex } = this.state;
    const { children } = this.props;

    const childProps = {
      currentIndex,
      getDisplayItemIndices: this.getDisplayItemIndicies,
      changeCurrentIndex: this.changeCurrentIndex,
    };

    return children(childProps);
  }
}

Carousel.propTypes = {
  totalNumberOfItems: PropTypes.number.isRequired,
  autoScroll: PropTypes.bool,
  autoScrollTime: PropTypes.number,
  numberOfDisplayItems: PropTypes.number,
};

Carousel.defaultProps = {
  autoScroll: false,
  autoScrollTime: 5000,
  numberOfDisplayItems: 3,
};
